<template>
  <div class="box">
    <h4 v-if="title">{{ title }}</h4>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
  },
  setup() {
    return {};
  },
};
</script>
